$(document).ready(function () {
    $(".allLangChoose").css('display', 'none');
});

$(".left_nav").on("wheel", function (event) {

    var targetDiv = $(".left_nav").filter(function () {
        if ($(this).css("left") !== "-100vw") {
            return $(this);
        }

    });

    if (targetDiv.length > 0) {
        // 判断是否能滚动
        var canScroll = targetDiv.get(0).scrollHeight > targetDiv.get(0).clientHeight;
        var canScrollHeight = targetDiv.get(0).scrollHeight - targetDiv.get(0).clientHeight;

        if (canScroll) {

            if (targetDiv.scrollTop() >= canScrollHeight) {
                // 判断鼠标是想往上滑还是往下滑
                if (event.originalEvent.wheelDelta < 0) {
                    event.preventDefault();
                } else {
                    event.stopPropagation();
                }
            } else {
                event.stopPropagation();
            }

        } else {
            event.preventDefault();
        }
        lastScroll = targetDiv.scrollTop();

    } else {
        event.preventDefault();

    }


});

// 导航栏显隐
function openLeft_nav() {
    //
    $(".left_nav").css('display', 'flex')
    //$(".left_nav").css({"width":"90vw","transition":"0.3s"});
    $(".left_nav").animate({ left: "0vw" }, 300, function () { });
    $("#black_bg").css("display", "block");
}

function closeLeft_nav() {

    $(".left_nav").animate({ left: "-100vw" }, 300, function () { });
    $("#black_bg").css("display", "none");
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// 搜索栏显隐
function searchClick() {

    if ($("#phone-searchFormDiv").css('display') === 'none') {
        $("#phone-searchFormDiv").slideDown();
    } else {
        $("#phone-searchFormDiv").slideUp();
    }

}


// 菜单栏点击事件
// 入参i为被点击的菜单项层级
// index为第几个菜单栏
// parentTitle 父级标题
function menuClick(deep, index, parentTitle) {

    // 显隐下方隐藏菜单
    if (deep === 1) {
        $(".childLinkDiv").css('display', 'none');
        $("#childLinkDiv-" + index).css('display', 'flex');
    } else if (deep === 2) {
        $(".menuLinkProductListDiv").css('display', 'none')
        $("#menuLinkProductListDiv-" + index).css('display', 'flex');
    }


    $(".navDiv").css('display', 'none');
    $(".navDiv[data-index='" + (deep + 1) + "']").css('display', 'flex');
    $(".topMenuDiv[data-index='" + (deep + 1) + "']").text(parentTitle);
}

/**
 * 返回上一层级
 * @param deep
 */
function backClick(deep) {

    $(".navDiv").css('display', 'none');
    $(".navDiv[data-index='" + (deep - 1) + "']").css('display', 'flex');

}

// // 旋转箭头
// function rotatingArrow(deep,index,parentIndex){
//     var id = "#menuHeadArrow-" + deep + "-" + parentIndex + "-" + index;
//     if ($(id).css('transform') == "matrix(1, 0, 0, 1, 0, 0)"){
//         $(id).css('transform',"rotate(-180deg)")
//     }else {
//         $(id).css('transform',"rotate(0deg)")
//     }
//
// }

// 显隐下级菜单栏
function toggleChildLinkDiv(deep, index) {
    // if ($("#childLinkDiv-" + deep + "-" + index + "-" + index).css('display') == 'none'){
    //     $("#childLinkDiv-" + deep + "-" + index + "-" + index).slideDown(function (){
    //         slideFlag = true;
    //     });
    // }else {
    //     $("#childLinkDiv-" + deep + "-" + index + "-" + index).slideUp(function (){
    //         slideFlag = true;
    //     });
    // }
    //
    // if ($("#childLinkDiv-" + deep + "-" + index + "-" + index).length == 0 ){
    //     slideFlag = true;
    // }

}

// 地区选择框显隐藏
function chooseLocation(e) {

    if ($(".langChooseDiv").css('display') == 'none') {
        $(".langChooseDiv").slideDown(200, function () {
            $(".langChooseDiv").css('display', 'flex');
        });
    } else {
        $(".langChooseDiv").slideUp(200, function () {
            $(".langChooseDiv").css('display', 'none');
        });
    }

}

$(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    var headerHeight = $(".phoneHeadNavDiv .header").outerHeight(true);

    if (scrollPosition > headerHeight) {
        $(".phoneHeadNavDiv .header").css('position', 'fixed');
        $("#phone-searchFormDiv").css('position', 'fixed');
        $("#phone-searchFormDiv").css('top', '4.8rem');
    } else if (scrollPosition <= 0) {
        $(".phoneHeadNavDiv .header").css('position', 'relative');
        $("#phone-searchFormDiv").css('position', 'relative');
        $("#phone-searchFormDiv").css('top', '0rem');
    }
});

